import React from "react";
import {
  Box,
  Grid,
  ImageList,
  ImageListItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@emotion/react";

const Showcase = ({
  title,
  subtitle,
  images,
  children,
  alt = false,
  ...props
}) => {
  console.log("images", images);
  const theme = useTheme();
  const isXsBreakPoint = useMediaQuery(theme.breakpoints.down("sm"));

  const cols = isXsBreakPoint ? 1 : 4;

  return (
    <Box>
      <Grid
        container
        spacing={2}
        style={{
          paddingBottom: "3rem",
        }}
      >
        <Grid item xs={12} md={12}>
          {/*  Main content */}
          {/* title and subtitle */}
          <Typography variant="h3" component="h1" gutterBottom>
            {title}
          </Typography>
          <Typography variant="h5" component="h2" gutterBottom>
            {subtitle}
          </Typography>
        </Grid>
        {images && images.length > 0 && (
          <Grid item xs={12} md={12}>
            {/*  Image that fills the grid */}
            <Box
              sx={{
                display: "flex",
                height: "100%",
                padding: "0rem 2rem",
              }}
            >
              <ImageList
                variant="masonry"
                cols={cols}
                gap={16}
                style={{
                  marginBottom: "0",
                  overflow: "visible",
                }}
              >
                {images.map((item, index) => (
                  <ImageListItem key={(item, index)}>
                    <img
                      srcSet={`${item}?w=248&fit=crop&auto=format&dpr=2 2x`}
                      src={`${item}?w=248&fit=crop&auto=format`}
                      // alt={item.alt}
                      loading="lazy"
                      style={{
                        borderRadius: "1rem",
                        boxShadow: "0px 0px 42px 0px rgba(0,0,0,0.5)",
                      }}
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Showcase;
